import {UserData} from 'APIs/letrusAPI/user/types';

const STORAGE_KEY = 'userData';

export interface LocalUserData {
  user: UserData['user'];
  userRole: UserData['user_roles'][0];
  userRoleList: UserData['user_roles'];
  userProfile: UserData['user']['user_profile'];
}

export function getUserData(): LocalUserData {
  const userData: UserData = JSON.parse(
    localStorage.getItem(STORAGE_KEY) || 'null',
  );

  return {
    user: userData?.user,
    userRole: userData?.user_roles[0],
    userRoleList: userData?.user_roles,
    userProfile: userData?.user.user_profile,
  };
}

export function updateUserData(param: string, newValue: any) {
  const storedUserData = localStorage.getItem(STORAGE_KEY);

  if (!storedUserData) return;

  const userData = JSON.parse(storedUserData);

  function updateRecursive(value: any): any {
    if (Array.isArray(value)) {
      return value.map((item) => updateRecursive(item));
    }

    if (value && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value).map(([key, val]) => {
          if (key === param) {
            return [key, newValue];
          }
          return [key, updateRecursive(val)];
        }),
      );
    }

    return value;
  }

  const updatedData = updateRecursive(userData);

  setUserData(updatedData);
}

export function setUserData(userData: UserData) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
}

export function clearUserData() {
  localStorage.removeItem(STORAGE_KEY);
}
